/** @format */
import { css } from 'styled-components';

import { PaymentMethodsProps, PaymentMethodsSize } from './index';

/**
 * Base styles for the payment methods component
 *
 * @param {PaymentMethodsProps} props The payment methods properties object
 * */
/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
const baseStyles = css`
    .payment-methods {
        display: flex;
        margin: 0;
        padding: 0;
        list-style: none;
    }

    .payment-icon {
        display: block;
        height: 100%;
        margin: 0 0.5rem;

        svg {
            display: block;
            height: 100%;
            max-width: 4.5rem;
        }

        &:first-of-type {
            margin-left: 0;
        }

        &:last-of-type {
            margin-right: 0;
        }
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

/**
 * Size styles for the payment methods component
 *
 * @param {PaymentMethodsProps} props The payment methods properties object
 * @param {PaymentMethodsColour} props.size The size of the PaymentMethods component
 * */
const sizeStyles = ({ size }: PaymentMethodsProps) => {
    switch (size) {
        case PaymentMethodsSize.SMALL:
            return css`
                .payment-methods {
                    height: 1.6rem;
                }
            `;

        case PaymentMethodsSize.LARGE:
        default:
            return css`
                .payment-methods {
                    height: 2.4rem;
                }
            `;
    }
};

/**
 * The payment methods component styles
 *
 * @param {PaymentMethodsProps} props The payment methods properties object
 * */
export const styles = (props: PaymentMethodsProps) => css`
    ${baseStyles}
    ${sizeStyles(props)}
`;
